import React from "react";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import ReactTable from "react-table";
import CardBody from "components/Card/CardBody.jsx";
import { PulseLoader } from "react-spinners";
import API from "@aws-amplify/api";
import withStyles from "@material-ui/core/styles/withStyles";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Cookies from "universal-cookie";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "components/CustomButtons/Button.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import CryptoJS from "crypto-js";
import NavPills from "components/NavPills/NavPills.jsx";
import LoadingOverlay from "react-loading-overlay";
import { css } from "react-emotion";
import "assets/scss/styles.css";

const cookies = new Cookies();
const data = [
  {
    name: "Tanner Linsley",
    age: 26,
    temp: "jsdgndsi",
  },
  {
    name: "Datta Joshi ",
    age: 28,
    temp: "sdhsdhsf",
  },
];
// core components
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align: center;
  margin-top: 10px;
`;
let apiName = process.env.REACT_APP_AMPLIFY_API;
class ViewLists extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      loading: true,
      tr: false,
      color: "success",
      message: "",
    };
  }
  showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        10000
      );
    }
  }

  downloadList(listUrl) {
    try {
      if ("listDownload" in listUrl) {
        window.location.href = listUrl["listDownload"];
      } else {
        let listsPath = "/lists";
        let listsInit = {
          headers: {
            clientId: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("clientId"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
          },
        };
        API.get(apiName, listsPath, listsInit)
          .then((response) => {
            let copyOfresponse = response.filter((x) => x.id == listUrl["id"]);
            if ("listDownload" in copyOfresponse[0]) {
              window.location.href = copyOfresponse[0]["listDownload"];
            } else {
              this.setState({ color: "warning" });
              this.setState({
                message:
                  "The file is not yet created! Please check back later.",
              });
              this.showNotification("tr");
            }
          })
          .catch((error) => {
            console.log(error.response);
            this.setState({ color: "warning" });
            this.setState({ message: "The file has been removed." });
            this.showNotification("tr");
          });
      }
    } catch (err) {
      console.log("error", err);
      this.setState({ color: "warning" });
      this.setState({ message: "The file has been removed." });
      this.showNotification("tr");
    }
  }
  copyListId(listId) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = listId;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }

  addFilterPlaceholder = () => {
    const filters = document.querySelectorAll("div.rt-th > input");
    for (let filter of filters) {
      filter.placeholder = "Search";
    }
  };

  //function to sort the results
  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
      : true;
  };

  componentDidMount() {
    this.addFilterPlaceholder();
    let listsPath = "/lists";
    let listsInit = {
      headers: {
        clientId: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("clientId"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
      },
    };
    API.get(apiName, listsPath, listsInit)
      .then((response) => {
        let copyOfresponse = response.filter(
          (x) =>
            x.clientConcept ==
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("globalFilter"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )
        );
        for (let i in copyOfresponse) {
          copyOfresponse[i]["actions"] = (
            <div className="actions-right">
              <Tooltip title="Download">
                <Button
                  justIcon
                  color="info"
                  onClick={() => this.downloadList(copyOfresponse[i])}
                >
                  <i
                    style={{ fontSize: "14px" }}
                    className={"fa fa-cloud-download-alt fa-1x"}
                  />
                </Button>
              </Tooltip>
              <Tooltip title="Copy list id">
                <Button
                  justIcon
                  color="warning"
                  onClick={() => this.copyListId(copyOfresponse[i]["id"])}
                >
                  <i
                    style={{ fontSize: "14px" }}
                    className={"fa fa-copy fa-1x"}
                  />
                </Button>
              </Tooltip>
            </div>
          );
        }
        this.setState({ listData: copyOfresponse, loading: false });
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  render() {
    let showSpinner =
      this.state.loading === true ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div
              style={{ textAlign: "center", marginTop: "20px", width: "100%" }}
            >
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: "50px" }}
              />
            </div>
          </GridItem>
        </GridContainer>
      ) : (
        "No records found"
      );
    return (
      <GridContainer style={{ paddingTop: "1em" }}>
        <GridItem xs={12} sm={12} md={3}>
          <Snackbar
            place="tr"
            color={this.state.color}
            message={this.state.message}
            open={this.state.tr}
            closeNotification={() => this.setState({ tr: false })}
            close
          />
        </GridItem>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="warning" icon>
              <CardIcon color="warning">
                <Assignment />
              </CardIcon>
              <h4 style={{ color: "#0c3c54" }}>Lists</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={this.state.listData}
                filterable
                defaultFilterMethod={(filter, row) =>
                  this.filterCaseInsensitive(filter, row)
                }
                columns={[
                  {
                    Header: "Audience Title",
                    accessor: "audienceTitle",
                  },
                  {
                    Header: "Title",
                    accessor: "title",
                  },
                  {
                    Header: "Description",
                    accessor: "description",
                  },
                  {
                    Header: "Customer Type",
                    accessor: "customerType",
                  },
                  /*{
                  Header: "Marketable Customers",
                  accessor: "finalCount"
                },
                {
                  Header: "Marketable",
                  accessor: "emailCount"
                },
                {
                  Header: "Control",
                  accessor: "nonemailCusts"
                },*/
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false,
                  },
                ]}
                defaultPageSize={10}
                //showPaginationTop
                showPaginationBottom={true}
                noDataText={showSpinner}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}
export default withStyles(userProfileStyles)(ViewLists);



// WEBPACK FOOTER //
// ./src/views/Lists/ViewLists.jsx